import { render, staticRenderFns } from "./ListProposalRefuseReasons.vue?vue&type=template&id=4770aa2b"
import script from "./ListProposalRefuseReasons.vue?vue&type=script&lang=js"
export * from "./ListProposalRefuseReasons.vue?vue&type=script&lang=js"
import style0 from "./ListProposalRefuseReasons.vue?vue&type=style&index=0&id=4770aa2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports